import { useContext, useEffect, useState } from "react";
import styles from "./ContactForm.module.css";
import Modal from "./Modal";
import NavigationContext from "../store/navigation-context";
import Input from "./Input";
import Button from "./Button";
import ContactRow from "./ContactRow";

import phoneIcon from "../../assets/navigation/phone-icon-colored.png";
import mailIcon from "../../assets/navigation/mail-icon-colored.png";
import locationIcon from "../../assets/navigation/location-icon.png";
import logo from "../../assets/navigation/logo-vertical.png";
import exit from "../../assets/x-highlight.png";
import usePostEMail from "../hooks/_REST API/POST/use-post-email";
import PostStatusFeedback from "./PostStatusFeedback";
import DataContext from "../store/data-context";

export default function ContactForm() {
  const navCtx = useContext(NavigationContext);
  const dataCtx = useContext(DataContext);
  const [respStatus, sendEMail] = usePostEMail();

  const [name, setName] = useState("");
  const [nameError, setNameError] = useState(false);

  const [surname, setSurname] = useState("");
  const [surnameError, setSurnameError] = useState(false);

  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState(false);

  const [title, setTitle] = useState("");
  const [titleError, setTitleError] = useState(false);

  const [description, setDescription] = useState("");
  const [descriptionError, setDescriptionError] = useState(false);

  const [imNotARobot, setImNotARobot] = useState(false);

  useEffect(() => {
    if (respStatus === 2) {
      setTimeout(() => {
        setName("");
        setSurname("");
        setEmail("");
        setTitle("");
        setDescription("");
      }, [2500]);
    }
  }, [respStatus]);

  const sendEmailHandler = (e) => {
    e.preventDefault();

    if (name.length === 0 || name.length > 50) {
      setNameError(true);
      return;
    }

    if (surname.length === 0 || surname.length > 50) {
      setSurnameError(true);
      return;
    }

    if (
      email.length === 0 ||
      email.length > 50 ||
      !email.match(
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      )
    ) {
      setEmailError(true);
      return;
    }

    if (title.length === 0 || title.length > 100) {
      setTitleError(true);
      return;
    }

    if (description.length === 0 || description.length > 2000) {
      setDescriptionError(true);
      return;
    }

    const data = {
      hp_check: imNotARobot,
      contact_name: name + " " + surname,
      contact_email: email.toLowerCase(),
      subject: title,
      contact_message: description,
    };

    sendEMail(data);
  };

  return (
    <Modal
      onClose={() => {
        navCtx.setIsContacting(false);
      }}
    >
      <main className={styles.main}>
        <img
          className={styles.exit}
          src={exit}
          alt="X"
          onClick={() => {
            navCtx.setIsContacting(false);
          }}
        />
        <PostStatusFeedback
          respStatus={respStatus}
          success={"Poruka uspješno poslana!"}
          fail={"Greška prilikom slanja poruke, pokušajte ponovo kasnije!"}
        />
        <form className={styles.form} onSubmit={sendEmailHandler}>
          <div className={styles.title}>
            {dataCtx.pageData.contact.contact_title}
          </div>

          <div className={styles[`naming`]}>
            <Input
              setValue={setName}
              value={name}
              label={dataCtx.pageData.contact.name}
              error={nameError}
              setError={setNameError}
            />
            <Input
              setValue={setSurname}
              value={surname}
              label={dataCtx.pageData.contact.surname}
              error={surnameError}
              setError={setSurnameError}
            />
          </div>
          <Input
            setValue={setEmail}
            value={email}
            label={dataCtx.pageData.contact.email}
            error={emailError}
            setError={setEmailError}
          />
          <Input
            setValue={setTitle}
            value={title}
            label={dataCtx.pageData.contact.subject}
            error={titleError}
            setError={setTitleError}
          />

          <Input
            isTextArea={true}
            setValue={setDescription}
            value={description}
            label={dataCtx.pageData.contact.message}
            error={descriptionError}
            setError={setDescriptionError}
          />

          <input
            id="ImNotArobot"
            name="ImNotArobot"
            type="checkbox"
            checked={imNotARobot}
            onChange={(e) => {
              setImNotARobot(e.target.checked);
            }}
            tabIndex="-1"
            autoComplete="off"
            style={{
              position: "absolute",
              left: "-9999px",
              width: "1px",
              height: "1px",
              overflow: "hidden",
            }}
          />

          <div className={styles[`button-container`]}>
            <Button type="submit">
              {dataCtx.pageData.contact.send_button}
            </Button>
          </div>
        </form>
        <div className={styles.info}>
          <img className={styles.logo} src={logo} alt="Logo." />
          <div className={styles.contacts}>
            <ContactRow
              isMobile={true}
              icon={phoneIcon}
              info="+385 992406888"
            />
            <ContactRow
              isMobile={true}
              icon={mailIcon}
              info="hogast@hogast.hr"
            />
            <ContactRow
              isMobile={true}
              icon={locationIcon}
              info="HOGAST D.O.O., Štrigova 134, 40312 Štrigova"
            />
          </div>
        </div>
      </main>
    </Modal>
  );
}
